import { Component } from '@angular/core';

@Component({
  selector: 'app-water-mark',
  templateUrl: './water-mark.component.html',
  styleUrls: ['./water-mark.component.scss']
})
export class WaterMarkComponent {}
